import { render, staticRenderFns } from "./AreaDetails.vue?vue&type=template&id=65dd0533&"
import script from "./AreaDetails.vue?vue&type=script&lang=js&"
export * from "./AreaDetails.vue?vue&type=script&lang=js&"
import style0 from "./AreaDetails.vue?vue&type=style&index=0&id=65dd0533&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports